// src/admin/pages/Overview.jsx
import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement,
  BarElement, BarController, Title, Tooltip, Legend,
} from 'chart.js';
import PageHeader from '../components/PageHeader';
import StatCard from '../components/StatCard';
import { fetchUsers, fetchAllLogins, fetchSubmissions } from '../lib/adminApi';
import { bucketByDay, computeUserKpis, toDate } from '../lib/adminLogic';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, BarController, Title, Tooltip, Legend);

export default function Overview() {
  const [kpis, setKpis] = useState(null);
  const [signupChart, setSignupChart] = useState({ labels: [], datasets: [] });
  const [loginChart, setLoginChart] = useState({ labels: [], datasets: [] });

  useEffect(() => {
    (async () => {
      const [users, logins, pending] = await Promise.all([
        fetchUsers(), fetchAllLogins(), fetchSubmissions(true),
      ]);
      const k = computeUserKpis(users);
      setKpis({ ...k, pending: pending.length });

      const su = bucketByDay(users, (u) => u.createdAt, 30);
      setSignupChart({
        labels: su.labels,
        datasets: [{ label: 'Iscrizioni', data: su.counts, borderColor: 'rgba(75,192,192,1)', backgroundColor: 'rgba(75,192,192,0.2)' }],
      });

      const lg = bucketByDay(logins, (l) => toDate(l.timestamp), 30);
      setLoginChart({
        labels: lg.labels,
        datasets: [{ label: 'Accessi', data: lg.counts, borderColor: 'rgba(255,99,132,1)', backgroundColor: 'rgba(255,99,132,0.2)' }],
      });
    })();
  }, []);

  return (
    <>
      <PageHeader title="Panoramica" subtitle="Metriche chiave della piattaforma" />
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={6} md={3}><StatCard label="Utenti totali" value={kpis?.total ?? '—'} icon={<PeopleIcon fontSize="small" />} to="/admin/users" /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Utenti Pro" value={kpis?.proCount ?? '—'} icon={<WorkspacePremiumIcon fontSize="small" />} to="/admin/users" /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Conversione Pro" value={kpis ? `${kpis.proConversion}%` : '—'} icon={<WorkspacePremiumIcon fontSize="small" />} /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Richieste in attesa" value={kpis?.pending ?? '—'} icon={<HowToRegIcon fontSize="small" />} to="/admin/requests" /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Nuovi (7g)" value={kpis?.newLast7 ?? '—'} icon={<PeopleIcon fontSize="small" />} /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Nuovi (30g)" value={kpis?.newLast30 ?? '—'} icon={<PeopleIcon fontSize="small" />} /></Grid>
        <Grid item xs={6} md={3}><StatCard label="Amministratori" value={kpis?.adminCount ?? '—'} icon={<PeopleIcon fontSize="small" />} /></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card><CardContent>
            <Typography variant="h6">Iscrizioni (30 giorni)</Typography>
            <Line data={signupChart} />
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card><CardContent>
            <Typography variant="h6">Accessi (30 giorni)</Typography>
            <Line data={loginChart} />
          </CardContent></Card>
        </Grid>
      </Grid>
    </>
  );
}
